<template>
  <div class="shop-container" style="padding-bottom: 1.3rem;">
    <ph-header>
      <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
    </ph-header>
    <section class='userinfo mb24'>
      <div class="userinfo-avtor">
        <img :src="userInfo.profilePicture" alt="" style="border-radius: 50%;">
      </div>
      <div class="userinfo-text">
        <div class="userinfo-text_tel">{{userInfo.nickname}}</div>
        <div class="userinfo-text_info">新精英奢侈品生活方式</div>
      </div>
      <div class="userinfo_bonus">
        <a href="javascript:;" @click="myWallet">
        <p>{{userInfo.accountBalance}}</p><p>钱包</p>
        </a>
        <a href="javascript:;"></a>
        <span @click="goAllowance">
          <p>{{userInfo.bonusBalance}}</p><p>奖励金</p>
        </span>
        <a href="javascript:;"></a>
        <a href="javascript:;" @click="goCard">
          <p>{{userInfo.couponNumber}}</p><p>优惠券</p>
        </a>
      </div>
    </section>

    <van-cell-group class="user-group mb24">
      <van-cell id="message" icon="slot" title="消息通知" is-link to="/user/notice">
        <van-tag slot="default" round color="#DA3232" v-if="userInfo.unreadMessage>0">{{userInfo.unreadMessage}}</van-tag>
      </van-cell>
      <van-cell id="list" icon="slot" title="我的购买" is-link to='/order'/>
      <van-cell id="jianding" icon="slot" title="我的鉴定" is-link :url="appraiser_url" />
      <van-cell id="huishou" icon="after-sale" title="我的回收" is-link :url="recover_url+'orderlist'"/>
    </van-cell-group>

    <van-cell-group class="user-group">
      <van-cell  id="address" icon="location-o" title="收货地址" is-link to="/user/address" />
      <van-cell  id="connect" icon="slot" title="联系客服" value="工作日10：00-18：30" @click="custService=true" />
      <van-cell id="xieyi" icon="slot" title="用户协议" is-link url="https://m.ponhu.cn/Ht/xieyi.html" />
      <van-cell id="yinsi" icon="slot" title="胖虎隐私政策" is-link url="https://m.ponhu.cn/Ht/privacy.html" />
      <van-cell id="about" icon="slot" title="关于我们" is-link url="https://m.ponhu.cn/User/about?os=2" />

    </van-cell-group>
    <div class="logout" @click="logout">
      <p>退出登录</p>
    </div>
    <!-- foot -->
    <TabBar /> 
    <van-action-sheet v-model="custService">
      <service-sheet @close="custService=false"></service-sheet>
    </van-action-sheet>
  </div>
</template>

<script>
import { getUserInfo } from '@/api/user'
import PhHeader from '@/components/common/Header'
import TabBar from '@/components/common/TabBar'
import ServiceSheet from '@/components/business/ServiceSheet' 
import { BrowserInfo } from '@/utils'
export default {
  name: 'center',
  components: {
    PhHeader,
    TabBar,
    ServiceSheet
  },
  data () {
    return {
      barActive: 'user',
      userInfo: {},
      custService: false,
      appraiser_url: process.env.VUE_APP_APPRASISER_URL + 'order/list',
      recover_url : process.env.VUE_APP_RECYCLE_URL
    }
  },
  computed: {
    UserToken () {
      return this.$store.getters.token || ''
    }
  },
  created () {
    if(this.UserToken) {
      this.getData();
    } else { // 跳转登录授权
      this.$router.push({ path: '/login?return_url=' + window.location.href })
    }
  },
  methods: {
    getData() {
      getUserInfo({ userToken: this.UserToken }).then(res => {
        console.log(res)
        this.userInfo = res;
      }).catch(error => {
        this.$toast(error)
      })
    },
    // logout() {
    //   this.$store.dispatch('LogOut')
    //   this.$dialog.confirm({
    //     title: "确定退出登录么",
    //   }).then(() => {
    //     this.$toast('已退出')
    //     this.$parent.onRefresh();
    //     // openApp('ponhu://')
    //   }).catch(() => {
    //   })
    //   this.$router.replace({ path: '/' })
    // }
    logout() {
      this.$store.dispatch('LogOut')
      this.$dialog.confirm({
        title: "确定退出登录么",
      }).then(() => {
        this.$toast('已退出')
        this.$router.replace({ path: '/' })
        // openApp('ponhu://')
      }).catch(() => {
        // this.$parent.onRefresh();
      })
    },
    myWallet(){
      location.href = this.recover_url+'wallet'
    },
    goAllowance(){
      if(BrowserInfo().isWeixin){
          this.$dialog.confirm({
          title: '提示',
          message: '下载胖虎奢侈品APP查看奖励金',
          confirmButtonText: '去下载'
        }).then(()=>{
          location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.gian.punkhoo'
        }).catch(()=>{})
      }else{
        this.$dialog.confirm({
          title: '提示',
          message: '下载胖虎奢侈品APP查看奖励金',
          confirmButtonText: '去下载'
        }).then(()=>{
          location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.gian.punkhoo'
        }).catch(()=>{})
      }
    },
    goCard(){
      this.$router.push({name : "cheapcard"})
    }
  }
}
</script>

<style lang="less">

.van-cell {
  display: flex;
  align-items: center;
}
.van-cell__left-icon {
  margin-top: 0 !important;
}
#message>i:nth-child(1),#connect>i:nth-child(1),
#jianding>i:nth-child(1),#about>i:nth-child(1),
#xieyi>i:nth-child(1),#about>i:nth-child(1),
#yinsi>i:nth-child(1),#about>i:nth-child(1),
#list>i:nth-child(1){
  display: block;
  width: 35px;
  height:33px;
  background:url(../../assets/img/icon_gy.png);
  background-size: 100%;
  margin-top: 10px;
}
#message>i:nth-child(1){background:url(./about/message.png);background-size: 100%;}
#connect>i:nth-child(1){background:url(./about/kefu.png);background-size: 100%;}
#jianding>i:nth-child(1){background:url(./about/jianding.png) no-repeat;background-size: 83%;}
#xieyi>i:nth-child(1){background:url(./about/icon_xieyi.png);background-size: 100%;}
#yinsi>i:nth-child(1){background:url(./about/icon_yinsi.png);background-size: 100%;}
#list>i:nth-child(1){background:url(./about/list.png);background-size: 100%;}
.userinfo{
  height:300px;
  background:url(../../assets/picture/usebg.png);
  background-size: 100%;
  color: #FFFFFFFF;
  font-size: 24px;
  position: relative;
  &-avtor{
    width:144px;
    height:144px;
    position: absolute;
    left: 60px;
    top: 40px;
  }
  &_bonus{
    width: 100%;
    height: 1.1rem;
    background: rgba(0,0,0,0.1);
    position: absolute;
    bottom: 0;
    a,span{
      width: 20%;
      height: 100%;
      float: left;
      margin-left: 55px;
      color: white;
      p{
        text-align: center;
        width: 100%;
        font-size: 30px;
        font-weight: bold;
        line-height: 20px;
        margin-top: 20px;
      }
      p:nth-child(2){
        font-size: 20px;
        font-weight: 400;
        margin-top: -10px;
      }
    }
    a:nth-child(even){
      width: 2px;
      height: 36px;
      background: white;
      margin-top: 3%;
    }
  }
  &-text{
    position: absolute;
    left: 246px;
    top: 70px;
    color: white;
    font-weight: 600;
    &_tel{
      font-size: 45px;
      font-weight: 600;
    }
    &_info{
      font-size: 20px;
      font-weight: 400;
      margin-top: 12px;
    }
    
  }
}
.logout{
  width: 100%;
  height: 70px;
  text-align: center;
  font-size: 28px;
  line-height: 75px;
  color: black;
  background: white;
}
.van-hairline--top {
  .action-btn {
    width: 100%;
    height: 100%;
    border: 0;
    background-color: transparent;
  }
  a {
    color: #323233;
  }
}
.action-btn {
  width: 100%;
  height: 100%;
  border: 0;
  background-color: transparent;
}
.van-icon-after-sale:before{
  font-size: 19px;
}
.van-icon-location-o:before{
  font-size: 19px;
}
#about i:nth-child(1){
  height: .48rem;
}
.mb24{
  margin-bottom: .2rem;
}
.van-cell__right-icon{
  position: absolute;
  right: 4%;
}
.van-cell__value{
  padding-right: 6%;
}
</style>














